import { SOCKET_STATUS } from "constants/common.constants";
import { useEffect, useState } from "react";

const DEFAULT_LOADING_STATUS = { datasetLoading: false, validationLoading: false };

export const useSetFileTrack = ({ dataset_id, token }) => {
  const [loadingStatus, setLoadingStatus] = useState(DEFAULT_LOADING_STATUS);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (!dataset_id || !token) return;

    const url = `${process.env.REACT_APP_DATA_SET_SOCKET_URL_}/${dataset_id}/?token=${token}`;

    const socket = new WebSocket(url);

    socket.onopen = () => {
      setResponse(null);
      setLoadingStatus({ datasetLoading: true, validationLoading: true });
    };

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);

      console.log("onmessage event", data);
      if (data) {
        setResponse(data);
        setLoadingStatus((prev) => ({ ...prev, datasetLoading: false }));

        if (data.status === SOCKET_STATUS.READY_VALIDATION) {
          setLoadingStatus((prev) => ({ ...prev, validationLoading: false }));
          socket.close();
        }
      }
    };

    socket.onerror = (event) => {
      console.log("onerror event", event);
    };

    socket.onclose = () => {
      setLoadingStatus(DEFAULT_LOADING_STATUS);
    };

    //return () => {
    //socket.close();
    //setResponse(null);
    //};
  }, [dataset_id, token]);

  return {
    loading: loadingStatus.datasetLoading,
    validationLoading: loadingStatus.validationLoading,
    response,
    setResponse,
  };
};
